/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IEventId, IEventTime, ISuccess, TSuccessNumber, TSuccessString } from '../interfaces';

export const EVENT_CLIENT_RENDER_START = 'ClientRenderEventStart';
export const EVENT_CLIENT_RENDER_STOP = 'ClientRenderEventStop';
export const CONTENT_SECURITY_POLICY_ERROR = 'Content Security Policy error';

/**
 * Additional properties to send along with ending a request
 */
export interface IEventClientRenderProperties extends IEventId, ISuccess<TSuccessString> {}

export interface IEventClientRenderMetrics extends IEventTime, ISuccess<TSuccessNumber> {}
